import { useState, useEffect } from 'react';
import { IconButton } from "@mui/material";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography, CircularProgress, Divider, TextField, Box, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";
import FieldView from 'core/components/layout/FieldView';
import { setImageType, setIntegratedImage, setLinkAssetOption } from 'store/slice/ImageGallerySlice';
import DisplayAsset from './DisplayAsset';
import ProductassetDashboard from 'components/productasset/ProductassetDashboard';
import { linkAssetToProductAPI } from './DesignMgmtAPI';
import DesignerUploadDesign from './DesignerUploadDesign';
import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import { sendDesignToCustomerApprovalAPI, revokeCustomerApprovalAPI, approveProductDesignAPI, submitDesignQaApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import { updateProductObj, updatePharmaorderObj } from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import CustomerApprovedDesign from './CustomerApprovedDesign';
import DesignerUploadQADesign from './DesignerUploadQADesign';
import DesignerReviewQAComments from './DesignerReviewQAComments';
import DesignerPlaceMaterialOrder from './DesignerPlaceMaterialOrder';


export default function DesignMgmt() {
    const dispatch = useDispatch();
    const { apiInProgress } = useSelector((state) => state.headerslice);
    const { selectedImagePath, selectedImage, imageType } = useSelector((state) => state.imagegalleryslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productassetList, productassetDashboard } = useSelector((state) => state.pharmaslice);
    const [assetAdded, setAssetAdded] = useState(false)
    const {selectedTaskObj, taskList} = useSelector((state) => state.appslice.wkflow);
    
    // const [apiInProgress, setApiInProgress] = useState(false);
    const [err, setErr] = useState('');
    const [designTab, setDesignTab] = useState(
        productObj.statusname === 'PLANNING' ? 'material' : 'customer'
    );
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        dispatch(setImageType("CUSTOMER"));
    }, [])

    // Update designTab if productObj.statusname changes to PLANNING
    useEffect(() => {
        if (productObj.statusname === 'PLANNING') {
            setDesignTab('material');
        }
    }, [productObj.statusname]);

    const submitToCustomerApproval = () => {

        dispatch(setApiInProgress(true));
        sendDesignToCustomerApprovalAPI(
            { "productid": productObj.id }, submitToCustomerApprovalSuccessCallBack, () => { }
        )
    }
    const submitToCustomerApprovalSuccessCallBack = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))

        if (responseObj.pharmaorderInfo !== null)
            dispatch(updatePharmaorderObj(responseObj.pharmaorderInfo))
    }
    const revokeCustomerApproval = () => {
        dispatch(setApiInProgress(true));
        revokeCustomerApprovalAPI(
            { "productid": productObj.id }, revokeCustomerApprovalSuccessCallBack, () => { }
        )
    }
    const revokeCustomerApprovalSuccessCallBack = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))

        if (responseObj.pharmaorderInfo !== null)
            dispatch(updatePharmaorderObj(responseObj.pharmaorderInfo))
    }
    const markAsCustomerApprovedFailureCallBack = (response) => {
        dispatch(setApiInProgress(false));
        setErr(response);
    }

    const markAsCustomerApproved = () => {
        setErr('');
        dispatch(setApiInProgress(true));
        approveProductDesignAPI(
            { "productId": productObj.id }, markAsCustomerApprovedSuccessCallBack, markAsCustomerApprovedFailureCallBack
        )
    }
    const markAsCustomerApprovedSuccessCallBack = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))

        if (responseObj.pharmaorderInfo !== null)
            dispatch(updatePharmaorderObj(responseObj.pharmaorderInfo))
    }

    const submitForQAapprovalSuccessCallBack = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))

        if (responseObj.pharmaorderInfo !== null)
            dispatch(updatePharmaorderObj(responseObj.pharmaorderInfo))
    }
    const submitForQAapprovalFailureCallBack = (response) => {
        dispatch(setApiInProgress(false));
        setErr(response);
    }
    const submitForQAapproval = () => {
        if (parseInt(productassetDashboard.productassetList.length) === 0) {
            setErr("Please add image under 'QA Tab' before submit it for 'QA Approval'");
            return;
        }
        /*
        if (productObj.statusname!=='CUSTOMER APPROVED'){
            setErr("Design should be 'Customer Approved' before it can be submitted for 'QA Approval'");
            return;
        }
            */

        setErr('');
        dispatch(setApiInProgress(true));
        submitDesignQaApprovalAPI(
            { "productId": productObj.id }, submitForQAapprovalSuccessCallBack, submitForQAapprovalFailureCallBack
        )
    }
    const getComponent = () => {
        if (designTab === 'customer') {
            if (productObj.statusname === 'CUSTOMER APPROVED') {
                return <CustomerApprovedDesign />;
            } else {
                return <DesignerUploadDesign />;
            }
        } else if (designTab === 'qa') {
            if (productObj.designstatusqa !== '') {
                return <DesignerReviewQAComments />;
            } else {
                return <DesignerUploadQADesign />;
            }
        } else if (designTab === 'material') {
            return <DesignerPlaceMaterialOrder />;
        }
    }
    return (
        <>
            <Grid
                container
                direction={{ xs: 'column', md: 'row' }}
                wrap="nowrap"
                sx={{
                    height: { lg: '78vh', md: '70vh', xs: '80vh' },
                    columnGap: { xs: 0, md: 2, lg: 3 },
                }}
            >
                {/* First Section: Design Management (collapsible on mobile) */}
                {(!collapsed || window.innerWidth >= 900) && (
                    <Grid
                        item
                        lg={3}
                        md={2}
                        sm={12}
                        xs={12}
                        sx={{
                            height: '100%',
                            mb: { xs: 1, md: 0 },
                            display: { xs: 'block', md: 'block' }
                        }}
                    >
                        <Box sx={{ backgroundColor: 'white', borderRadius: 5, }}>
                            <Box sx={{ padding:1, display: 'flex', alignItems: 'center', borderRadius:2, justifyContent: 'space-between', backgroundColor:'primary.darker' }}>
                                <FormLabel
                                    component="legend"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 0, // Remove margin bottom for vertical centering
                                        color: 'white',
                                        flex: 1,
                                        m:1,
                                        textAlign: 'left', // Center text horizontally in its flex space
                                    }}
                                >
                                    Design Actions
                                </FormLabel>
                                {/* Collapse/Expand button only on mobile */}
                                <IconButton
                                    size="small"
                                    sx={{ display: { xs: 'inline-flex', md: 'none' }, ml: 1 }}
                                    onClick={() => setCollapsed(true)}
                                    aria-label="Collapse"
                                >
                                    <ExpandLessIcon />
                                </IconButton>
                            </Box>
                            {/* Only show radio group if not collapsed or on desktop */}
                            {(!collapsed || window.innerWidth >= 900) && (
                                <FormControl component="fieldset" sx={{ width: '100%', padding:1 }}>
                                    <RadioGroup
                                        aria-label="design-management"
                                        name="design-management"
                                        value={designTab}
                                        onChange={e => setDesignTab(e.target.value)}
                                        row
                                        sx={{
                                            flexDirection: { xs: 'row', md: 'column' }
                                        }}
                                    >
                                        <FormControlLabel value="customer" control={<Radio />} label="Approval Confirmation" />
                                        <FormControlLabel
                                            value="qa"
                                            control={<Radio />}
                                            label="Designs for QA Approval"
                                            disabled={productObj.designstatus !== "CUSTOMER APPROVED"}
                                        />
                                        <FormControlLabel
                                            value="material"
                                            control={<Radio />}
                                            disabled={
                                                !(selectedTaskObj?.taskid === 3 || productObj.designstatusqa === "QA APPROVED")
                                            }
                                            label="Material Order"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            )}
                        </Box>
                    </Grid>
                )}
                {/* Second Section: Content */}
                <Grid item lg={9} md={9} sm={12} xs={12} sx={{ height: '100%', position: 'relative' }}>
                    {/* Show expand button if collapsed on mobile */}
                    {collapsed && window.innerWidth < 900 && (
                        <Box
                            sx={{
                                display: { xs: 'flex', md: 'none' },
                                mb: 2,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                borderRadius: 2,
                                px: 2,
                                py: 1,
                                boxShadow: 1,
                                width: '100%',
                            }}
                        >
                            <Typography sx={{ fontWeight: 600 }}>Design Management</Typography>
                            <IconButton
                                size="small"
                                onClick={() => setCollapsed(false)}
                                aria-label="Expand"
                                sx={{ backgroundColor: 'white', borderRadius: 1, ml: 1 }} // <-- removed boxShadow
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        </Box>
                    )}
                    {/* Always show content */}
                    <>
                        {getComponent()}
                    </>
                </Grid>
            </Grid>
        </>
    )
}